var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 2.6H15.76C15.2 1.092 13.7333 0 12 0C10.2667 0 8.8 1.092 8.24 2.6H2.66667C1.95942 2.6 1.28115 2.87393 0.781048 3.36152C0.280951 3.84912 0 4.51044 0 5.2V23.4C0 24.0896 0.280951 24.7509 0.781048 25.2385C1.28115 25.7261 1.95942 26 2.66667 26H21.3333C22.0406 26 22.7189 25.7261 23.219 25.2385C23.719 24.7509 24 24.0896 24 23.4V5.2C24 4.51044 23.719 3.84912 23.219 3.36152C22.7189 2.87393 22.0406 2.6 21.3333 2.6ZM12 2.6C12.3536 2.6 12.6928 2.73696 12.9428 2.98076C13.1929 3.22456 13.3333 3.55522 13.3333 3.9C13.3333 4.24478 13.1929 4.57544 12.9428 4.81924C12.6928 5.06304 12.3536 5.2 12 5.2C11.6464 5.2 11.3072 5.06304 11.0572 4.81924C10.8071 4.57544 10.6667 4.24478 10.6667 3.9C10.6667 3.55522 10.8071 3.22456 11.0572 2.98076C11.3072 2.73696 11.6464 2.6 12 2.6ZM5.33333 7.8H18.6667V5.2H21.3333V23.4H2.66667V5.2H5.33333V7.8ZM6 16.25L8 14.3L10.6667 16.9L16.6667 11.05L18.6667 13L10.6667 20.8L6 16.25Z",
    fill: "#03212B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq7);
export default __webpack_public_path__ + "static/media/faq7.cc3c912f0a7439cdc63ef569bd399236.svg";
export { ForwardRef as ReactComponent };